import React from "react";
import { motion } from "framer-motion";

/**
 * Small motion primitives used across sections – keeps everything cohesive.
 */

export const fadeUp = {
    hidden: { opacity: 0, y: 24 },
    show: (i = 0) => ({
        opacity: 1,
        y: 0,
        transition: { duration: 0.7, delay: i * 0.08, ease: [0.16, 1, 0.3, 1] },
    }),
};

export function Reveal({ children, delay = 0, y = 24, className = "", as: Tag = "div", ...rest }) {
    return (
        <motion.div
            initial={{ opacity: 0, y }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.25 }}
            transition={{ duration: 0.7, delay, ease: [0.16, 1, 0.3, 1] }}
            className={className}
            {...rest}
        >
            {children}
        </motion.div>
    );
}

export function ChapterChip({ n, label }) {
    return (
        <div className="chapter-chip mb-5" data-testid={`chapter-${n}`}>
            <span className="num">{n.toString().padStart(2, "0")}</span>
            <span className="text-navy-500">{label}</span>
        </div>
    );
}

export function SectionHeading({ chapter, chapterLabel, title, kicker, className = "" }) {
    return (
        <div className={`max-w-3xl ${className}`}>
            {chapter && <ChapterChip n={chapter} label={chapterLabel} />}
            {kicker && <div className="text-gold-500 font-semibold text-sm uppercase tracking-widest mb-3">{kicker}</div>}
            <h2 className="font-display font-extrabold tracking-tight text-navy-950 text-[32px] sm:text-[42px] lg:text-[52px] leading-[1.05]">
                {title}
            </h2>
        </div>
    );
}
